import PaginationProps from 'src/dto/common/PaginationProps.dto';
export interface NotifPagination extends PaginationProps {
  descendingOrder?: boolean;
}
export interface NotificationData {
  content: string;
  messageId: string;
  notificationActivationTime: number;
  isRead: boolean;
  relationId: string;
  sourceObjectId: string;
  sourceObjectType: string;
}

export enum SourceObjectType {
  RFQ_PLAN = 'RFQ_PLAN',
  INQUIRY = 'INQUIRY',
  SHIPMENT = 'SHIPMENT',
  HAWB = 'HAWB',
}

export const NotificationLabelColor = {
  RFQ_PLAN : '#d6ebcc',
  INQUIRY : '#FFF8DF',
  SHIPMENT : '#E2F5FB',
  HAWB : '#FBE2EC',
}

export const AirCargoResourceType = {
  HAWB : 'HAWB',
  AIR : 'AIR'
}